"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg24LocationPinDisabledFill = function Svg24LocationPinDisabledFill(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.293 1.293a1 1 0 0 1 1.414 0L6.18 4.766A7.49 7.49 0 0 1 12 2c4.14 0 7.5 3.352 7.5 7.492 0 1.506-.452 3.01-1.023 4.335-.32.742-.693 1.466-1.087 2.15l5.317 5.316a1 1 0 0 1-1.414 1.414l-20-20a1 1 0 0 1 0-1.414zm3.252 7.373a7.57 7.57 0 0 0-.045.826c0 1.506.452 3.01 1.023 4.335.579 1.343 1.334 2.625 2.063 3.719a35.702 35.702 0 0 0 2.669 3.5c.088.102.177.203.268.302a2 2 0 0 0 2.952.003c.324-.354.632-.723.935-1.096.226-.277.483-.601.76-.964L4.544 8.666zm8.595 3.06A2.5 2.5 0 1 0 9.774 8.36l3.366 3.366z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg24LocationPinDisabledFill.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg24LocationPinDisabledFill;
exports.default = _default;